export default __webpack_public_path__ + "static/10-6c4036357ea701d2ff1f777e8b24dd13.webp";